import api from '../api/http';

const discount = {
    async getDiscount(payloads) {
        let url = `/v1/venue/get_discount?code=${payloads.code}`

        return await api.get(url)
    }
}

export default discount


// WEBPACK FOOTER //
// ./src/api/discount.js